import { forwardRef, useState } from "react";
import { hsvaToHex, hexToHsva } from "@uiw/color-convert";

import CustomPickerModal from "./CustomPickerModal";
import { CustomColorPicker } from "@theorgchartdev/storybook";
import {
  AccountSettingsSectionRoutes,
  getAccountSettingsTestPrefix
} from "@/providers/NavigationProvider";

const themeTestPrefix = getAccountSettingsTestPrefix(AccountSettingsSectionRoutes.Theme);

const CustomColorPickerModal = forwardRef((props, ref) => {
  const [hsva, setHsva] = useState(hexToHsva("#ff0000"));

  const handleSave = () => {
    const hexColor = hsvaToHex(hsva);
    props.onSave(hexColor);
    props.onClose();
  };

  return (
    <CustomPickerModal
      ref={ref}
      show={props.show}
      onClose={props.onClose}
      onSave={handleSave}
      cancelTestId={`${themeTestPrefix}-solid-color-cancel-btn`}
      saveTestId={`${themeTestPrefix}-solid-color-save-btn`}
    >
      <CustomColorPicker
        hsva={hsva}
        callbackFn={color => {
          setHsva(color.hsva);
        }}
      />
    </CustomPickerModal>
  );
});

export default CustomColorPickerModal;
